import React from 'react';

const PriorityBadge = ({ priority }) => {
  // Set base style
  const baseStyle = {
    display: 'inline-block',
    padding: '3px 6px',
    minWidth: '80px',
    textAlign: 'center',
    fontSize: '0.875rem',
    fontWeight: 500,
    borderRadius: '0.5rem',
    color: 'white',
  };

  // Customize background color based on priority
  let backgroundColor;
  let textColor = 'white';

  switch (priority) {
    case 'High':
      backgroundColor = '#dc3545'; // danger
      break;
    case 'Medium':
      backgroundColor = '#ffc107'; // warning
      textColor = '#212529';       // dark text for contrast
      break;
    default:
      backgroundColor = '#28a745'; // success
  }

  const style = {
    ...baseStyle,
    backgroundColor,
    color: textColor,
  };

  return <span style={style}>{priority}</span>;
};

export default PriorityBadge;
